<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="filter_headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-layout row wrap v-if="!is_sale">
                        <v-flex lg12>
                            <v-btn class="ml-3" small @click="exportExcel">
                                <v-icon class="mr-3" color="#0f7896">fa fa-file-excel-o</v-icon>  Xuất excel
                            </v-btn>
                            <v-btn class="ml-3" small @click="exportExcelBuy">
                                <v-icon class="mr-3" color="#0f7896">fa fa-file-excel-o</v-icon>  Hàng cần mua
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100" item-key="id" show-select v-model="selected">
                        <template v-slot:item="{ item, isSelected, select }">
                            <tr :active="isSelected" @click="select(!isSelected)">
                                <td>
                                    <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
                                </td>
                                <td>{{ item.id }}</td>
                                <td>{{ item.created_at | display_date }}</td>
                                <td><img :src="'/'+item.path" alt="" style="height: 56px; width: 56px;"></td>
                                <td>{{ item.customer_first_name }} {{ item.customer_last_name }}</td>
                                <td class="text-start" v-bind:style="{'color': display_color(item.status, order_status)}" >{{ item.status | display_value(order_status) }}</td>
                                <td class="text-start">{{ item.shipment_status | display_value(order_shipment_status) }}</td>
                                <td class="text-start">
                                    <h4><a target="_blank" :href="'/quan-ly-san-pham/san-pham-ban/' + item.product_id">{{ item.name }}</a></h4>
                                    <h4>{{ item.product_code }}</h4>
                                    <h4><b>Tổng SL:</b><span class="text-red">{{ item.qty | currency }}</span></h4>
                                </td>
                                <td class="text-start">
                                    <template v-if="item.options && item.options.length > 0">
                                        <ul>
                                            <li v-for="op in item.options" :key="op.order_product_id">
                                                {{ op.option_label }} (SL: {{ op.qty }})
                                            </li>
                                        </ul>
                                    </template>
                                </td>
                                <td class="text-end">{{ item.total | currency }}</td>
                                <td class="text-start">{{ item.admin_note }}</td>
                                <td class="text-center">
                                    <v-icon medium class="mr-2" @click="openItem(item)">edit</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogItem" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="title">Chi tiết đơn hàng</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md pa-0>
                <v-layout row wrap>
                    <v-flex lg12>
                        <v-autocomplete label="Khách hàng" v-model="currentItem.customer_id" :items="customers" :item-text="getCustomerText" item-value="id" class="input-group--focused" :disabled="currentItem.id > 0"></v-autocomplete>
                    </v-flex>
                    <v-flex lg12 v-if="!currentItem.id">
                        <v-autocomplete label="Sản phẩm" v-model="currentItem.product_id" :items="products" :item-text="getProductText" item-value="id" class="input-group--focused" @change="onSelectedProduct"></v-autocomplete>
                    </v-flex>
                    <v-flex lg12 v-else-if="selectedItemList">
                        Sản phẩm: <h4>{{ selectedItemList.product_code }} ({{ selectedItemList.name }})</h4>
                    </v-flex>
                    <v-flex lg12 v-if="currentItem.id > 0">
                        <v-checkbox v-model="isUpdateProp" label="Cập nhật thuộc tính" class="input-group--focused"></v-checkbox>
                    </v-flex>
                    <v-flex lg12 v-if="!currentItem.id || isUpdateProp">
                        <div class="product_option" v-if="selectedProduct.options && selectedProduct.options.length > 0">
                            <v-layout row wrap v-for="op in selectedProduct.options" :key="op.id">
                                <v-flex lg4 md4 sm12>
                                    <h4>{{ op.name }}</h4>
                                </v-flex>
                                <v-flex lg8 md8 sm12 v-if="op.position == 0">
                                    <ul class="list-inline-1">
                                        <li v-for="val in op.option_values" :key="val.id" v-bind:class="{ 'has_image': op.has_image && val.path, 'active': val.id == selectedFirstOption.id, 'choised': getFirstOptionQty(val.id) > 0}"  @click="selectedFirstOption = val">
                                            <img :src="'/'+val.path" alt="Option image" v-if="op.has_image && val.path">
                                            <p v-else>{{ val.label }}</p>
                                        </li>
                                    </ul>
                                </v-flex>
                                <v-flex lg8 md8 sm12 v-else>
                                    <ul class="list-inline-2">
                                        <li v-for="val in op.option_values" :key="val.id" class="number-picker" v-bind:class="{'choised': getOrderOption(selectedFirstOption.id, val.id) > 0}">
                                            <label v-bind:style="{'text-decoration': selectedProduct.manage_stock && selectedProduct.is_sale && getInventory(selectedFirstOption.id, val.id) == 0 ? 'line-through' : 'none'}" for="qty">{{ (selectedFirstOption ? selectedFirstOption.label + ' - ' : '') + val.label }}</label>
                                            <input min="0" max="100" type="number" placeholder="0" :value="getOrderOption(selectedFirstOption.id, val.id)" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, val.option_id, val.id, event.target.value)">
                                            <h6 v-if="selectedProduct.manage_stock && selectedProduct.is_sale" v-bind:style="{'color': getInventory(selectedFirstOption.id, val.id) == 0 ? 'red' : 'blue'}">(có sẵn: {{ getInventory(selectedFirstOption.id, val.id) }})</h6>
                                        </li>
                                    </ul>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap v-if="selectedProduct.options.length == 1 && selectedFirstOption">
                                <v-flex lg4 md4 sm12>
                                </v-flex>
                                <v-flex lg8 md8 sm12>
                                    <ul class="list-inline-2">
                                        <li class="number-picker single">
                                            <label v-bind:style="{'text-decoration': selectedProduct.manage_stock && selectedProduct.is_sale && getInventory(selectedFirstOption.id, 0) == 0 ? 'line-through' : 'none'}" for="qty">{{ selectedFirstOption.label }}</label>
                                            <input min="0" max="100" type="number" placeholder="0" :value="getOrderOption(selectedFirstOption.id, 0)" @input="event => updateOrderOption(selectedFirstOption.option_id, selectedFirstOption.id, 0, 0, event.target.value)">
                                            <h6 v-if="selectedProduct.manage_stock && selectedProduct.is_sale" v-bind:style="{'color': getInventory(selectedFirstOption.id, 0) == 0 ? 'red' : 'blue'}">(có sẵn: {{ getInventory(selectedFirstOption.id, ) }})</h6>
                                        </li>
                                    </ul>
                                </v-flex>
                            </v-layout>
                        </div>
                        <ul class="product_option list-inline-2" v-else>
                            <li class="number-picker single">
                                <label for="qty">Số lượng</label>
                                <input min="0" max="100" type="number" placeholder="0" :value="getOrderOption(0, 0)" @input="event => updateOrderOption(0, 0, 0, 0, event.target.value)">
                                <h6 v-if="selectedProduct.manage_stock && selectedProduct.is_sale" v-bind:style="{'color': getInventory(0,0) == 0 ? 'red' : 'blue'}">(có sẵn: {{ getInventory(0,0) }})</h6>
                            </li>
                        </ul>
                    </v-flex>
                    <v-flex lg12 v-if="currentItem.id > 0">
                        <v-text-field label="Admin note" v-model="currentItem.admin_note" class="input-group--focused"></v-text-field>
                    </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
              <v-btn @click="placeOrder">Lưu lại</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="multipleDialog" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="title">Cập nhật đơn hàng</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md pa-0>
                <v-layout row wrap>
                    <v-flex lg12 v-if="!multipleUpdate.is_update_all">
                        <h4 class="red--text">Cập nhật {{ selected.length }} đơn hàng đã chọn.</h4>
                    </v-flex>
                    <v-flex lg6>
                        <v-autocomplete label="Trạng thái" v-model="multipleUpdate.status" :items="order_status_edit" item-text="name" item-value="value" class="input-group--focused"></v-autocomplete>
                    </v-flex>
                    <v-flex lg6>
                        <v-autocomplete label="Trạng thái giao hàng" v-model="multipleUpdate.shipment_status" :items="order_shipment_status" item-text="name" item-value="value" class="input-group--focused"></v-autocomplete>
                    </v-flex>
                    <v-flex lg12>
                        <v-checkbox label="Cập nhật tất cả đơn hàng" v-model="multipleUpdate.is_update_all" class="input-group--focused"></v-checkbox>
                    </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1 white--text" @click="multipleDialog = false">Đóng</v-btn>
              <v-btn @click="bulkUpdateData">Lưu lại</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-container>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import Filtering from "@/components/Filtering";
    import { display_color } from "@/commons/formater";
    import { sendErrorNotice } from '@/commons/utils'
    import _ from "lodash";
    
    export default {
        components: {
            "hpo-filter": Filtering
        },
        data() {
            return {
                viewName: "order_list",
                dialogItem: false,
                display_color: display_color,
                headers: [
                    {
                        text: "ID",
                        value: "id",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Ngày tạo",
                        value: "created_at",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "Hình ảnh",
                        value: "path",
                        filterable: false,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Họ tên",
                        value: "customer_first_name",
                        quickSearch: true,
                        filterable: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Trạng thái",
                        value: "status",
                        filterable: true,
                        values: configs.ORDER_STATUS,
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Tình trạng",
                        value: "shipment_status",
                        filterable: true,
                        values: configs.ORDER_SHIPMENT_STATUS,
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: "Sản phẩm",
                        value: "name",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Thuộc tính",
                        value: "options",
                        filterable: false,
                        sortable: false,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "Tổng tiền",
                        value: "total",
                        filterable: true,
                        align: "end",
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: "Admin note",
                        value: "admin_note",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: "",
                        value: "",
                        align: "center",
                        sortable: false,
                        filterable: false
                    }
                ],
                order_status: configs.ORDER_STATUS,
                order_status_edit: _.filter(configs.ORDER_STATUS, (p) => {return p.value != 'khach_huy_don'}),
                order_shipment_status: configs.ORDER_SHIPMENT_STATUS,
                pagination: {...configs.PAGINATION, itemsPerPage: 100},
                items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
                filterConditions: [],
                quickFilterConditions: [],
                requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
                selectedFirstOption: {},
                order_options: [],
                selectedItemList: null,
                isUpdateProp: false,
                selected: [],
                multipleDialog: false,
                multipleUpdate: {}
            };
        },
        watch: {
            pagination: {
                handler: function (val, oldVal) {
                    let filterConditions = this.$store.state.commons.filterConditions;
                    this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                    this.filter_data();
                },
                deep: true
            },
            selectedProduct() {
                if (this.selectedProduct) {
                    this.selectedFirstOption = this.selectedProduct.options && this.selectedProduct.options.length > 0 ? this.selectedProduct.options[0].option_values[0] : {};
                }
            },
            currentPath() {
                this.filter_data();
            }
        },
        computed: {
            ...mapState({
                items: state => state.orders.all.data,
                total_rows: state => state.orders.all.total,
                loading: state => state.orders.loading,
                currentItem: (state) => state.orders.selected,
                customers: state => state.users.all.data,
                products: state => state.products.all.data,
                selectedProduct: state => state.products.selected,
                inventories: state => state.products.selected.inventories,
            }),
            role_list() {
                return _.filter(configs.ROLES, (p) => {return p.value == configs.ROLE_TYPE.Customer});
            },
            totalQty() {
                return _.sumBy(this.order_options, "value");
            },
            filter_headers() {
                return this.headers.concat([{
                        text: "Mã sản phẩm",
                        value: "product_code",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },]);
            },
            filter_param() {
                let param = {
                    pagination: this.pagination,
                    filter: [...this.filterConditions],
                    quickFilter: this.quickFilterConditions
                };
                
                if(this.currentPath && this.currentPath.includes('don-sale')) {
                    param.filter.push({column: 'orders.is_sale', value: 1, condition: "equal"});
                }
                else {
                    param.filter.push({column: 'orders.is_sale', value: 1, condition: "does_not_equal"});
                }
                return param;
            },
            is_sale() {
                return this.currentPath.includes('don-sale') ? 1: 0;
            },
            currentPath() {
                return this.$route.path;
            },
        },
        methods: {
            add_date_range_filter() {
                if(this.filterConditions.length == 0) {
                    let start_date = new URL(location.href).searchParams.get('start_date');
                    let end_date = new URL(location.href).searchParams.get('end_date');
                    if(start_date || end_date) {
                        _.remove(this.filterConditions, {'column': 'created_at'})
                    }
                    if(start_date) {
                        this.filterConditions.push({column: 'created_at', value: start_date, condition: "d_greater_than_or_equal"});
                    }
                    if(end_date) {
                        this.filterConditions.push({column: 'created_at', value: end_date, condition: "d_less_than_or_equal"});
                    }
                }
            },
            filter_data: function () {
                this.add_date_range_filter();
                this.$store.dispatch("orders/getList", this.filter_param);
                this.selected = [];
            },
            applyFilter(filterConditions) {
                let sortBy = this.pagination.sortBy
                let sortDesc = this.pagination.sortDesc
                this.pagination = configs.PAGINATION;
                this.pagination.sortBy = sortBy;
                this.pagination.sortDesc = sortDesc;
                this.filterConditions = filterConditions;
                this.filter_data();
            },
            quickFilter(filterConditions) {
                this.quickFilterConditions = filterConditions;
                this.filter_data();
            },
            openItem: function (item = {}) {
                this.order_options = [];
                if(!item.id) {
                    this.$store.commit("orders/setDetail", {'id': item.id});
                    this.selectedItemList = null;
                }
                else {
                    this.$store.dispatch("orders/getDetail", item.id);
                    this.selectedItemList = item;
                }
                if(item.product_id > 0) {
                    this.$store.dispatch("products/getDetail", item.product_id);
                }
                else {
                    this.$store.commit("products/setDetail", {data: {}});
                }
                this.dialogItem = true;
            },
            deleteItem: function(id) {
                window.getApp.$emit('REQUEST_DELETE_DATA', id);
            },
            editItem() {
                this.$store.dispatch("orders/setDetail", {
                    'data': {...this.currentItem},
                    'id': this.currentItem.id
                });
                this.dialogItem = false;
            },
            getCustomerText(item) {
                return `${item.phone} - ${item.first_name}`
            },
            getProductText(item) {
                return `${item.product_code} - ${item.name}`
            },
            onSelectedProduct() {
                if(this.currentItem.product_id > 0) {
                    this.$store.dispatch("products/getDetail", this.currentItem.product_id);
                }
                else {
                    this.$store.commit("products/setDetail", {data: {}});
                }
            },
            updateOrderOption(first_op_id, first_opvl_id, last_op_id, last_opvl_id, value) {
                let item = _.find(this.order_options, {'first_op_id': first_op_id, 'first_id': first_opvl_id, 'last_op_id': last_op_id, 'last_id': last_opvl_id });
                if (item) {
                    item['value'] = Number(value);
                }
                else {
                    this.order_options.push({'first_op_id': first_op_id, 'first_id': first_opvl_id, 'last_op_id': last_op_id, 'last_id': last_opvl_id , 'value': Number(value) });
                }
            },
            getOrderOption(first_id, last_id) {
                let item = _.find(this.order_options, {'first_id': first_id, 'last_id': last_id });
                return item ? item.value : 0;
            },
            getFirstOptionQty(first_id) {
                return _.sumBy(this.order_options, (p) => {return p.first_id == first_id ? p.value : 0});
            },
            getInventory(first_id, last_id) {
                if(!this.selectedProduct.options || this.selectedProduct.options.length == 0) return this.selectedProduct.qty;
                let item = _.find(this.inventories, {'option_value1_id': first_id, 'option_value2_id': last_id });
                return item ? item.qty : 0;
            },
            placeOrder() {
                if(this.totalQty == 0 && (this.isUpdateProp || !this.currentItem.id)) {
                    sendErrorNotice('Hãy chọn số lượng sản phẩm cần mua.');
                    return;
                }
                if(!this.currentItem.id) {
                    const price = this.selectedProduct.is_sale ? this.selectedProduct.special_price : this.selectedProduct.price;
                    this.$store.dispatch("orders/setDetail", {data:{
                        is_sale: this.selectedProduct.is_sale,
                        product_id: this.selectedProduct.id,
                        customer_id: this.currentItem.customer_id,
                        qty: this.totalQty,
                        price: price,
                        order_note: '',
                        multipleOptions: this.order_options,
                        sub_total: this.totalQty * price,
                        total: this.totalQty * price
                    }});
                }
                else {
                    this.$store.dispatch("orders/setDetail", {data:{
                        ...this.currentItem,
                        action: this.isUpdateProp ? 'update_options' : '',
                        product_id: this.selectedItemList.product_id,
                        customer_id: this.selectedItemList.customer_id,
                        qty: this.totalQty,
                        price: this.selectedItemList.price,
                        multipleOptions: this.order_options,
                        sub_total: this.totalQty * this.selectedProduct.price,
                        total: this.totalQty * this.selectedProduct.price,
                    },
                    id: this.currentItem.id});
                }
                
                this.dialogItem = false;
            },
            bulkUpdateData() {
                let params = {filter: [...this.filterConditions], quickFilter: this.quickFilterConditions}
                params.filter.push({column: 'status', value: ['da_mua_hang', 'khach_huy_don', 'admin_huy_don'], condition: "not_in"})
                this.$store.dispatch("orders/setDetail", {data:{
                    ...this.multipleUpdate,
                    order_ids: _.map(this.selected, "id"),
                    action: 'multiple_update',
                    filter: params
                },
                id: 99999999999});
                this.multipleDialog = false;
                this.selected = [];
            },
            exportExcel() {
                this.$store.dispatch("orders/export_order", this.filter_param);
            },
            exportExcelBuy() {
                this.filter_param.filter.push({column: 'status', value: 'chua_mua_hang', condition: "s_equal"})
                this.$store.dispatch("orders/export_order_to_buy", this.filter_param);
            },
        },
        mounted() {
            let param = null;
            if(this.is_sale) {
                param = {filter: [{column: 'is_sale', value: this.is_sale ? 1 : 0, condition: "equal"}]}
            }
            this.$store.dispatch("products/getList", param);
            this.$store.dispatch("users/getList", {filter: [{column: 'role', value: configs.ROLE_TYPE.Customer, condition: "equal"}]});
            this.$root.$emit('REQUEST_ROOT_OPTION', {});
            this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$on("REQUEST_SAVE_DATA", () => {this.multipleDialog = true; this.multipleUpdate = {}});
            this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
                this.$store.dispatch("orders/removeDetail", id);
            });
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$off("REQUEST_SAVE_DATA");
            this.$root.$off("CONFIRMED_REMOVE_DATA");
        }
    };
    </script>
    